import React from "react";
import { Layout, Typography, Alert } from "antd";
import Surface from "../layouts/Surface";
import LoginTemplateWrapper from "./loginTemplate.style";
import AnimationWrapper from "../animations/AnimationWrapper";
import { LockFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { isMobile } from "react-device-detect";
const { Title, Text } = Typography;

const LoginTemplate = (props) => {
  const { children, title, subTitle, image, showForgot } = props;
  return isMobile ? (
    <LoginTemplateWrapper>
      <div className="mobile">
        <Surface className="mobile-outer-container">
          <div className="mobile-lock">
            <LockFilled className="icon" />
          </div>
          <div style={{ padding: "0 20px" }}>
            {title ? (
              <div className="title">
                <Title level={3}>{title}</Title>
                <Text type="secondary">{subTitle}</Text>
              </div>
            ) : null}
            {children}
          </div>
          <div id="firebaseui-auth-container"></div>
          {showForgot && (
            <Alert
              message={<FormattedMessage id="app.login.warning" />}
              description={
                <FormattedMessage id="app.login.warning_description" />
              }
              type="warning"
              showIcon
            />
          )}
        </Surface>
        {showForgot ? (
          <div className="forgotPassword">
            <Link to="/forgotpassword" className="signUpLink">
              <FormattedMessage id="app.login.resetPassword" />
            </Link>
            <div style={{ width: "10px" }} />
            <Text>
              <FormattedMessage id="app.login.forgotPassword" />
            </Text>
          </div>
        ) : null}
      </div>
    </LoginTemplateWrapper>
  ) : (
    <AnimationWrapper animation="fadeIn" duration={0.5}>
      <LoginTemplateWrapper>
        <Layout className="outer-container">
          <Surface className="inner-container">
            <div className="login-content">
              <div className="right-container">{image}</div>
              <div className="left-container">
                <div className="lock">
                  <LockFilled className="icon" />
                </div>
                <div style={{ padding: "0 20px" }}>
                  {title ? (
                    <div className="title">
                      <Title level={3}>{title}</Title>
                      <Text type="secondary">{subTitle}</Text>
                    </div>
                  ) : null}
                  {children}
                </div>
                <div id="firebaseui-auth-container"></div>
              </div>
            </div>
            <div style={{ paddingBottom: "40px" }}>
              {showForgot && (
                <Alert
                  message={<FormattedMessage id="app.login.warning" />}
                  description={
                    <FormattedMessage id="app.login.warning_description" />
                  }
                  type="warning"
                  showIcon
                />
              )}
            </div>
          </Surface>
          {showForgot ? (
            <div className="forgotPassword">
              <Text>
                <FormattedMessage id="app.login.forgotPassword" />
              </Text>
              <div style={{ width: "10px" }} />
              <Link to="/forgotpassword" className="signUpLink">
                <FormattedMessage id="app.login.resetPassword" />
              </Link>
            </div>
          ) : null}
        </Layout>
      </LoginTemplateWrapper>
    </AnimationWrapper>
  );
};

export default LoginTemplate;
